import { Airport } from "@/models/airport";
import { Flight } from "@/models/flight";

export const flightSuggestions = (
  flight: Flight,
  possibleAirports: Airport[]
) => {
  if (possibleAirports.length === 0 || !flight) {
    return [];
  }

  const candidateAirports = possibleAirports.filter(
    (airport) =>
      airport.iata !== flight.origin_airport.iata &&
      airport.iata !== flight.destination_airport.iata
  );

  const randomIndex = Math.floor(Math.random() * candidateAirports.length);
  return [
    candidateAirports[randomIndex],
    candidateAirports[(randomIndex + 1) % candidateAirports.length],
    flight.origin_airport,
  ]
    .sort(() => Math.random() - 0.5)
    .map((airport) => `${airport.city} (${airport.iata})`);
};
